import { Transaction, FinancialGoal, Category } from "../types";

export const getTransactions = (userId: string): Transaction[] => {
  try {
    const transactionsStr = localStorage.getItem(`transactions_${userId}`);
    return transactionsStr ? JSON.parse(transactionsStr) : [];
  } catch (error) {
    console.error("Erro ao obter transações:", error);
    return [];
  }
};

export const saveTransaction = (transaction: Transaction): boolean => {
  try {
    const transactions = getTransactions(transaction.userId);
    transactions.push(transaction);
    localStorage.setItem(
      `transactions_${transaction.userId}`,
      JSON.stringify(transactions)
    );
    return true;
  } catch (error) {
    console.error("Erro ao salvar transação:", error);
    return false;
  }
};

export const updateTransaction = (transaction: Transaction): boolean => {
  try {
    const transactions = getTransactions(transaction.userId);
    const index = transactions.findIndex((t) => t.id === transaction.id);
    if (index !== -1) {
      transactions[index] = transaction;
      localStorage.setItem(
        `transactions_${transaction.userId}`,
        JSON.stringify(transactions)
      );
      return true;
    }
    return false;
  } catch (error) {
    console.error("Erro ao atualizar transação:", error);
    return false;
  }
};

export const deleteTransaction = (
  userId: string,
  transactionId: string
): boolean => {
  try {
    const transactions = getTransactions(userId);
    const filteredTransactions = transactions.filter(
      (t) => t.id !== transactionId
    );
    localStorage.setItem(
      `transactions_${userId}`,
      JSON.stringify(filteredTransactions)
    );
    return true;
  } catch (error) {
    console.error("Erro ao deletar transação:", error);
    return false;
  }
};

export const getGoals = (userId: string): FinancialGoal[] => {
  try {
    const goalsStr = localStorage.getItem(`goals_${userId}`);
    return goalsStr ? JSON.parse(goalsStr) : [];
  } catch (error) {
    console.error("Erro ao obter metas:", error);
    return [];
  }
};

export const saveGoal = (goal: FinancialGoal): boolean => {
  try {
    const goals = getGoals(goal.userId);
    goals.push(goal);
    localStorage.setItem(`goals_${goal.userId}`, JSON.stringify(goals));
    return true;
  } catch (error) {
    console.error("Erro ao salvar meta:", error);
    return false;
  }
};

export const updateGoal = (goal: FinancialGoal): boolean => {
  try {
    const goals = getGoals(goal.userId);
    const index = goals.findIndex((g) => g.id === goal.id);
    if (index !== -1) {
      goals[index] = goal;
      localStorage.setItem(`goals_${goal.userId}`, JSON.stringify(goals));
      return true;
    }
    return false;
  } catch (error) {
    console.error("Erro ao atualizar meta:", error);
    return false;
  }
};

export const deleteGoal = (userId: string, goalId: string): boolean => {
  try {
    const goals = getGoals(userId);
    const filteredGoals = goals.filter((g) => g.id !== goalId);
    localStorage.setItem(`goals_${userId}`, JSON.stringify(filteredGoals));
    return true;
  } catch (error) {
    console.error("Erro ao deletar meta:", error);
    return false;
  }
};

export const getCategories = (): Category[] => {
  try {
    const categoriesStr = localStorage.getItem("categories");
    if (categoriesStr) {
      return JSON.parse(categoriesStr);
    }

    // Default categories
    const defaultCategories: Category[] = [
      // Income
      {
        id: "1",
        name: "Salary",
        type: "income",
        color: "#10b981",
        icon: "💰",
      },
      {
        id: "2",
        name: "Freelance",
        type: "income",
        color: "#3b82f6",
        icon: "💼",
      },
      {
        id: "3",
        name: "Investments",
        type: "income",
        color: "#8b5cf6",
        icon: "📈",
      },
      { id: "4", name: "Other", type: "income", color: "#6b7280", icon: "💵" },

      // Expenses
      {
        id: "5",
        name: "Food",
        type: "expense",
        color: "#ef4444",
        icon: "🍽️",
      },
      {
        id: "6",
        name: "Transport",
        type: "expense",
        color: "#f59e0b",
        icon: "🚗",
      },
      {
        id: "7",
        name: "Housing",
        type: "expense",
        color: "#8b5cf6",
        icon: "🏠",
      },
      {
        id: "8",
        name: "Health",
        type: "expense",
        color: "#ec4899",
        icon: "🏥",
      },
      {
        id: "9",
        name: "Education",
        type: "expense",
        color: "#06b6d4",
        icon: "📚",
      },
      {
        id: "10",
        name: "Entertainment",
        type: "expense",
        color: "#84cc16",
        icon: "🎮",
      },
      {
        id: "11",
        name: "Clothing",
        type: "expense",
        color: "#f97316",
        icon: "👕",
      },
      {
        id: "12",
        name: "Other",
        type: "expense",
        color: "#6b7280",
        icon: "💸",
      },
    ];

    localStorage.setItem("categories", JSON.stringify(defaultCategories));
    return defaultCategories;
  } catch (error) {
    console.error("Erro ao obter categorias:", error);
    return [];
  }
};
